import TableSegment from "./TableSegment"

export default TableSegment
